module.exports = __webpack_public_path__ + "img/ISO-pic4.8a85e011.png";